const findCode: string = `program findarray💩
var 🔢 arr[10]💩

🚀 🔢 find(🔢 target) {
  var 🔢 i ⬅️ 0💩
  🔁 (i ◀️ 10) {
    🤔 (arr[i] 🙌 target) {
      🤲 i💩
    }💩
    i ⬅️ i+1💩
  }
  🤲 -1💩
}

main() {
  var 🔢 i⬅️1💩
  🔁 (i◀️⬅️10) {
    arr[i-1] ⬅️ i💩
    i ⬅️ i+1💩
  }
  i ⬅️ 0💩

  🖨(🔤Array from 1 to 10.🔤)💩
  🔁 (i<10) {
    🖨(arr[i])💩
    i ⬅️ i+1💩
  }

  🖨(🔤🔤)💩
  🖨(🔤Find the position of 3🔤)💩
  🖨(find(3))💩

  🖨(🔤🔤)💩
  🖨(🔤Find the position of 12🔤)💩
  🖨(find(12))💩
}`;
export default findCode;
